import { createHash } from 'node:crypto';
import { mkdir, readFile, writeFile } from 'node:fs/promises';
import { join } from 'node:path';
import { debug } from './log';

let ngPackagrVersion: string | undefined;
try {
  ngPackagrVersion = require('../../package.json').version;
} catch {
  // dev path
  ngPackagrVersion = require('../../../package.json').version;
}

export async function generateKey(...valuesToConsider: string[]): Promise<string> {
  return createHash('sha256').update(ngPackagrVersion).update(valuesToConsider.join(':')).digest('hex');
}

async function ensureCacheDirExists(cachePath: string): Promise<void> {
  try {
    await mkdir(cachePath, { recursive: true });
  } catch (err: unknown) {
    if (!(typeof err === 'object' && err !== null && 'code' in err && (err as { code?: unknown }).code === 'EEXIST')) {
      throw err;
    }
  }
}

export async function readCacheEntry(cachePath: string, key: string): Promise<any> {
  try {
    const data = await readFile(getCacheFilePath(cachePath, key), 'utf8');

    return JSON.parse(data);
  } catch (err) {
    debug(`[readCacheError]: ${err}`);

    return undefined;
  }
}

export async function saveCacheEntry(cachePath: string, key: string, content: any): Promise<void> {
  // Ensure the cache directory exists
  await ensureCacheDirExists(cachePath);

  const data = JSON.stringify(content);

  return writeFile(getCacheFilePath(cachePath, key), data, 'utf8');
}

function getCacheFilePath(cachePath: string, key: string): string {
  return join(cachePath, `${key}.json`);
}
